const SgiBadgeEO = () => ({
	desId: "EP_EO_UI_4009"
});

export { SgiBadgeEO };
export default SgiBadgeEO;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiBadgeEO.js